export default "__VITE_ASSET__CQSHlFIL__"